var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { IdStyles } from "../../less/IdStyles";
import { selectOutskirtBuildingInfo } from "../../selectors/selectOutskirtBuildingInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { MenuInfoContentNonProductionDOM } from "../info-menu/MenuInfoContentNonProductionDOM";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var _DialogExternalBarnInfo = function (_a) {
    var building = _a.building, onClose = _a.onClose;
    var levels = (building.balancing.outsideBuildingStage || []).map(function (levelContent) { return (__assign({}, levelContent, { level: levelContent.level - 1 })); });
    var adjustedInfos = __assign({}, building, { balancing: __assign({}, building.balancing, { outsideBuildingStage: levels }) });
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.overview, onClose: onClose, className: "" + IdStyles.ModalBackgroundInfo },
        React.createElement(MenuInfoContentNonProductionDOM, { building: adjustedInfos })));
};
var mapState = function (state) { return ({
    building: selectOutskirtBuildingInfo(state, IdOutskirtBuildings.ExternalBarn),
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ExternalBarnInfo)); },
}); };
export var DialogExternalBarnInfo = connect(mapState, mapDispatch)(_DialogExternalBarnInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/external-barn/DialogExternalBarnInfo.tsx
// module id = 2822
// module chunks = 3